export default __webpack_public_path__ + "static/media/sopOutIcon.6185cb8a.svg";